import { render } from "./DemandTemplateTableRowMenu.vue?vue&type=template&id=78268857"
import script from "./DemandTemplateTableRowMenu.vue?vue&type=script&lang=ts"
export * from "./DemandTemplateTableRowMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script